export const LEAGUES_ENV = process.env.VUE_APP_FIREBASE_LEAGUES_ENV

export const GetLeaguePagePath = ({ activeLeagueKey, activeTeamKey, activePageName }) => {
	// League key and page name are always required
	if (!activeLeagueKey || !activePageName) {
		return null
	}

	// Team pages require a team key
	if (activePageName.startsWith("team_")) {
		if (!activeTeamKey) {
			return null
		}

		return `${LEAGUES_ENV}/${activeLeagueKey}/pages/${activePageName}_${activeTeamKey}`
	} else {
		return `${LEAGUES_ENV}/${activeLeagueKey}/pages/${activePageName}`
	}
}
